module.exports = __webpack_public_path__ + "static/media/icon_118.7ebeaf7a.svg";